export const ERROR_MESSAGE_BOARD_IS_LOCATIONLESS = 'Board is locationless';
export const ERROR_MESSAGE_BOARD_HAS_NO_COLUMN_MAPPED_TO_STATUS =
	'This board has no columns with a mapped status.';
